import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_BASIC_DETAILS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_BASIC_DETAIL:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_BASIC_DETAIL:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_BASIC_DETAIL:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_BASIC_DETAIL:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
